import { Colors } from '@fairhq/common'

export const getProgressColor = (percentage: number): string => {
  if (percentage < 75) {
    return Colors.YELLOW
  }
  return Colors.GREEN
}
